import { useComputed } from "@suse-o11y/signal";
import React from "react";

import { MetricQuery } from "~/models/metric-query";

import type { MonitorCheckStatusMetric } from "../../../../common/openapi";
import { Widget, WidgetBody, WidgetHeader } from "../../../../components/_widget";
import { ChartWidget } from "../../../../components/widget-form/widget";

import { useMonitorStatusDrawerContext } from "./MonitorStatusDrawer/use-monitor-status-drawer-context";
import { MONITOR_STATUS_DRAWER_QUERY_NAMESPACE } from "./_query-namespace";

interface MonitorStatusDrawerMetricsProps {
	metrics: ReadonlyArray<MonitorCheckStatusMetric>;
}

export const MonitorStatusDrawerMetrics: React.FC<MonitorStatusDrawerMetricsProps> = ({ metrics }) => {
	const { timestamp, timeRange } = useMonitorStatusDrawerContext();
	const timestampValue = useComputed(timestamp);
	const timeRangeValue = useComputed(timeRange);

	return (
		<Widget card>
			<WidgetHeader
				help="These metrics are automatically provided by the monitor as evidence for the triggered state. The metrics use the same time window as the telemetry interval set on the timeline."
				size="lg"
				title="Monitor triggering evidence"
			/>
			<WidgetBody className="flex gap-6">
				{metrics.map(({ name, unit, queries }) => (
					<ChartWidget
						batch={name}
						chart={{
							kind: "TimeSeriesChart",
							settings: { unit },
						}}
						className="flex-1"
						key={name}
						namespace={MONITOR_STATUS_DRAWER_QUERY_NAMESPACE}
						onTimeRangeChange={(nextTimeRange) => timeRange.write(nextTimeRange)}
						queries={queries.map(MetricQuery)}
						timeRange={timeRangeValue}
						timestamp={timestampValue}
						title={name}
					/>
				))}
			</WidgetBody>
		</Widget>
	);
};
